import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Timer, Wind } from "lucide-react";
import PhoenixImage from "../components/PhoenixImage";

const Home = () => {
  return (
    <div className="fade-in">
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#040c0e]/60 to-[#040c0e]" />
        <div className="relative max-w-6xl mx-auto px-6 pt-20 pb-32 md:pt-28 md:pb-40 grid md:grid-cols-[1.15fr_1fr] gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-teal-300/80 mb-8">
              <span className="w-6 h-px bg-teal-400/60" />
              The Pre-Therapy Standard
            </div>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.05]">
              <span className="text-neutral-100">Recovery </span>
              <span className="gradient-text">begins</span>
              <br />
              <span className="text-neutral-100">before the appointment.</span>
            </h1>
            {/* Decorative separator */}
            <div className="mt-8 mb-6 flex items-center gap-3 text-teal-300/50">
              <span className="h-px w-16 bg-teal-400/40" />
              <span className="rotate-45 inline-block w-2 h-2 border border-teal-400/60" />
              <span className="h-px w-16 bg-teal-400/40" />
            </div>
            <p className="max-w-xl text-neutral-300 text-lg leading-relaxed">
              You don't have to wait for a diagnosis, a therapist, or the "right time." Healing begins
              with one honest moment — and we're here for that moment.
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Link to="/studio" data-testid="hero-cta-studio" className="btn-primary px-7 py-3 inline-flex items-center gap-2">
                Enter The Studio <ArrowRight size={18} />
              </Link>
              <Link to="/story" data-testid="hero-cta-story" className="btn-ghost px-7 py-3">
                My Story
              </Link>
            </div>
          </div>

          {/* Phoenix illustration */}
          <div className="relative flex justify-center md:justify-end">
            <div className="absolute inset-0 rounded-full bg-teal-500/15 blur-3xl pointer-events-none" />
            <div className="relative w-full max-w-[440px]">
              <PhoenixImage variant="hero" />
            </div>
          </div>
        </div>
      </section>

      {/* Feature bento */}
      <section className="max-w-6xl mx-auto px-6 pb-24">
        <div className="grid md:grid-cols-3 gap-4">
          <div className="card-surface p-8 md:col-span-2">
            <Sparkles className="text-teal-400 mb-4" />
            <h3 className="font-display text-2xl mb-2">AI-assisted reflection</h3>
            <p className="text-neutral-400 leading-relaxed">
              Turn the mess of a hard morning into a message. Generate a morning mission, reframe a spiral,
              and save the language you need for later.
            </p>
          </div>
          <div className="card-surface p-8">
            <Timer className="text-teal-400 mb-4" />
            <h3 className="font-display text-2xl mb-2">60-second pivots</h3>
            <p className="text-neutral-400 leading-relaxed">
              A ritual timer for the peak of the craving. Log it. Watch your streak.
            </p>
          </div>
          <div className="card-surface p-8">
            <Wind className="text-teal-400 mb-4" />
            <h3 className="font-display text-2xl mb-2">The First 72 Hours</h3>
            <p className="text-neutral-400 leading-relaxed">A free grounding toolkit for anyone starting today.</p>
          </div>
          <div className="card-surface p-8 md:col-span-2 relative overflow-hidden">
            <h3 className="font-display text-2xl mb-2">Mapping the Cycle</h3>
            <p className="text-neutral-400 leading-relaxed max-w-md">
              An interactive workbook that traces the loop underneath the loop. Available in The Studio.
            </p>
            <span className="absolute right-6 top-6 text-xs uppercase tracking-widest text-teal-300/80 border border-teal-500/30 rounded-full px-3 py-1">
              $19.99
            </span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
